<template>
  <div
    class="bg-black lg:p-20 p-10 border-secondary text-white mt-20 border-b border-t w-full"
  >
    <div
      class="wrapper grid lg:max-w-5xl tracking-wide max-w-full mx-auto grid-cols-1 lg:grid-cols-4 lg:gap-5 gap-10"
    >
      <div class="w-full">
        <h1 class="text-2xl font-bluunext text-primary">Tautan Cepat</h1>
        <div
          class="menu-link mt-10 grid grid-cols-1 font-prozalibre text-xs text-gray-400 gap-5 uppercase"
        >
          <router-link to="/" class="hover:text-primary">Home</router-link>
          <router-link to="/" class="hover:text-primary"
            >Konsultasi</router-link
          >
          <router-link to="/" class="hover:text-primary">Weton</router-link>
          <router-link to="/" class="hover:text-primary">Kalender</router-link>
          <router-link to="/" class="hover:text-primary">Testimoni</router-link>
        </div>
      </div>
      <div class="w-full">
        <h1 class="text-2xl font-bluunext text-primary">Artikel</h1>
        <div
          class="menu-link mt-10 grid grid-cols-1 font-prozalibre text-xs text-gray-400 gap-5 uppercase"
        >
          <router-link to="/" class="hover:text-primary"
            >Konsultasi</router-link
          >
          <router-link to="/" class="hover:text-primary">Weton</router-link>
          <router-link to="/" class="hover:text-primary">Kalender</router-link>
        </div>
      </div>
      <div class="w-full">
        <h1 class="text-2xl font-bluunext text-primary">Ikuti Kami</h1>
        <div
          class="menu-link mt-10 grid grid-cols-1 font-prozalibre text-xs text-gray-400 gap-5 uppercase"
        >
          <router-link to="/" class="hover:text-primary">Facebook</router-link>
          <router-link to="/" class="hover:text-primary">Instagram</router-link>
          <router-link to="/" class="hover:text-primary">Twitter</router-link>
          <router-link to="/" class="hover:text-primary">Youtube</router-link>
        </div>
      </div>
      <div class="w-full">
        <h1 class="text-2xl font-bluunext text-primary">Hubungi Kami</h1>
        <div
          class="menu-link mt-10 grid grid-cols-1 font-prozalibre text-xs text-gray-400 gap-5 uppercase"
        >
          <router-link to="/" class="hover:text-primary">Facebook</router-link>
          <router-link to="/" class="hover:text-primary">Instagram</router-link>
          <router-link to="/" class="hover:text-primary">Twitter</router-link>
        </div>
      </div>
    </div>
  </div>
  <div class="copyright text-white p-10 w-full">
    <h2 class="text-center font-nunito">
      <b class="font-bold">Primbon</b> © 2022. All rights reserved.
    </h2>
  </div>
</template>
